<template>
  <v-container class="fill-height" fluid>
    <v-row justify="center">
      <v-col cols="12" sm="10" md="6" xl="4">
        <v-card class="pa-5" style="opacity: 0.88">
          <v-card-title>Thanks for your order!</v-card-title>
          <v-card-text>
            <v-alert>
              Subscription to <b>{{ product }}</b> successful!
            </v-alert>
          </v-card-text>
          <v-card-actions>
            <v-btn type="button" @click="gotoMap" color="green" dark>Search Map</v-btn>
            <v-spacer></v-spacer>

            <form :action="portalSessionUrl" method="POST">
              <input type="hidden" id="session-id" name="session_id" :value="session_id" />
              <!-- <v-btn id="checkout-and-portal-button" type="submit" text>Manage your billing information</v-btn> -->
            </form>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import {Component, Vue} from "vue-property-decorator"
import Logo from "./Logo.vue"
import {config} from "@/libs/utils"

@Component({
  components: {
    Logo,
  },
})
export default class SuccessDisplay extends Vue {
  portalSessionUrl = config.VUE_APP_SERVER_PAYMENT_API + "/v1/secure/user/payment/create-portal-session"

  // Data properties
  product = ""
  session_id = ""

  // Lifecycle hook
  created() {
    // Extract query param product and session_id
    this.product = this.$route.query.product as string
    this.session_id = this.$route.params.session_id as string
  }

  gotoMap() {
    this.$router.push({name: "mapview"})
  }
}
</script>

<style scoped>
/* Add your styles here */
</style>
